import { DatePickerProvider } from '@lfg/ui/providers/DatePickerProvider';
import { MuiProvider } from '@lfg/ui/providers/MuiProvider';
import '@rainbow-me/rainbowkit/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { theme } from './global/styles/theme.ts';
import './index.css';
import './sentry.ts';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MuiProvider theme={theme}>
      <DatePickerProvider>
        <App />
      </DatePickerProvider>
    </MuiProvider>
  </StrictMode>,
);
